import { ThemeProvider } from 'app-ui/theme';
import { type ReactNode } from 'react';

import { useColorScheme } from '@/ui/theme/hooks/useColorScheme';

type AppThemeProviderProps = {
  children: ReactNode;
};

export const AppThemeProvider = ({ children }: AppThemeProviderProps) => {
  const colorScheme = useColorScheme();

  return <ThemeProvider colorScheme={colorScheme}>{children}</ThemeProvider>;
};
